import { Link, useNavigate } from 'react-router-dom';
import './Home.css';

export default function Home() {
  const navigate = useNavigate();
  return (
    <div className="home">
      {/* Hero */}
      <section className="hero">
        <div className="hero-content">
          <span className="hero-icon">🥟</span>
          <h1>Parada Predileta</h1>
          <p className="hero-subtitle">Os melhores pastéis da cidade!</p>
          <p className="hero-text">
            Tradição e sabor em cada mordida. Pastéis recheados com ingredientes
            selecionados, feitos com carinho para você.
          </p>
          <div className="hero-buttons">
            <Link to="/cardapio" className="btn btn-primary btn-lg">
              🍽️ Ver Cardápio
            </Link>
            <Link to="/contato" className="btn btn-outline btn-lg">
              📞 Fale Conosco
            </Link>
          </div>
        </div>
      </section>

      {/* Destaques */}
      <section className="highlights">
        <div className="highlights-container">
          <h2>🌟 Por que nos escolher?</h2>
          <div className="highlights-grid">
            <div className="highlight-card">
              <span className="highlight-icon">🥟</span>
              <h3>Pastéis Artesanais</h3>
              <p>Massa crocante feita na hora, com recheios generosos e saborosos.</p>
            </div>
            <div className="highlight-card">
              <span className="highlight-icon">🚀</span>
              <h3>Entrega Rápida</h3>
              <p>Delivery direto para sua casa com tempo recorde de entrega.</p>
            </div>
            <div className="highlight-card">
              <span className="highlight-icon">💰</span>
              <h3>Preço Justo</h3>
              <p>Qualidade premium com preços acessíveis para toda a família.</p>
            </div>
            <div className="highlight-card">
              <span className="highlight-icon">⭐</span>
              <h3>Avaliação 5 Estrelas</h3>
              <p>Reconhecidos pelos nossos clientes pela qualidade e atendimento.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta">
        <div className="cta-content">
          <h2>Está com fome? 😋</h2>
          <p>Faça seu pedido agora pelo nosso cardápio digital!</p>
          <Link to="/cardapio" className="btn btn-primary btn-lg">
            🛒 Fazer Pedido
          </Link>
        </div>
      </section>

      {/* Acesso rápido para funcionários */}
      <section className="acesso-rapido">
        <button className="acesso-garcom" onClick={() => navigate('/garcom')}>
          🧑‍🍳 Área do Garçom
        </button>
        <button className="acesso-admin" onClick={() => navigate('/admin/login')}>
          🔐 Administração
        </button>
      </section>
    </div>
  );
}
